import { render, staticRenderFns } from "./InAppProductHeader.vue?vue&type=template&id=6fad8514&scoped=true"
import script from "./InAppProductHeader.vue?vue&type=script&lang=js"
export * from "./InAppProductHeader.vue?vue&type=script&lang=js"
import style0 from "./InAppProductHeader.vue?vue&type=style&index=0&id=6fad8514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad8514",
  null
  
)

export default component.exports